"use client"

import { StoryCardDto } from "api"
import { useInView } from "react-intersection-observer"
import { trackArticleClick } from "utils/gtm"
import ChevronIcon from "./ChevronIcon"
import { formatStoryDate } from "./formatStoryDate"
import {
  FeaturedArrow,
  FeaturedCard,
  FeaturedImg,
  FeaturedScrim,
  FeaturedTag,
  FeaturedTextWrap,
  FeaturedTitle,
  Meta,
  MetaDot,
  TagBar,
  TagCategory,
  TagPill,
} from "./storiesSection.styled"

type Props = { story: StoryCardDto; revealDelay?: number }

const FeaturedStory = ({ story, revealDelay = 0 }: Props) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  return (
    <FeaturedCard
      ref={ref}
      className={`be-reveal${inView ? " in-view" : ""}`}
      style={{ animationDelay: `${revealDelay}ms` }}
    >
      {story.image?.imageUrl && (
        <FeaturedImg src={story.image.imageUrl} alt={story.image.alt ?? ""} />
      )}
      <FeaturedScrim />

      {(story.badge || story.category) && (
        <FeaturedTag>
          <TagBar />
          {story.category && (
            <TagCategory dir="auto">{story.category}</TagCategory>
          )}
          {story.badge && <TagPill dir="auto">{story.badge}</TagPill>}
        </FeaturedTag>
      )}

      <FeaturedTextWrap>
        {story.title && <FeaturedTitle dir="auto">{story.title}</FeaturedTitle>}
        {(story.readTime || story.date) && (
          <Meta $onDark>
            {story.date && (
              <span dir="auto">{formatStoryDate(story.date)}</span>
            )}
            {story.readTime && story.date && <MetaDot />}
            {story.readTime && <span dir="auto">{story.readTime}</span>}
          </Meta>
        )}
      </FeaturedTextWrap>

      <FeaturedArrow
        href={story.url || "#"}
        aria-label={story.title}
        onClick={() => trackArticleClick(story.title ?? "")}
      >
        <ChevronIcon size={20} />
      </FeaturedArrow>
    </FeaturedCard>
  )
}

export default FeaturedStory
